export const gitCommit = '8478276d'
